import React, { useState, useEffect, Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { ButtonBase, Container, makeStyles } from "@material-ui/core";
import { txtA, txtE } from "../../../../Label/Lbl";
import { useBody, useHeader } from "../../bill-template02/style";
import QrBarcode from "./QrBarcode";
import tafqeet from "../../../../utils/tafqeet";
import i18next from "i18next";

function Footer(props) {
    const { InvForFatora, found, sta, locInv } = props;
    const clas = useInvAF();
    const calssBody = useBody();
    const classHeader = useHeader();

    const invColors = sta?.StngIA?.colors;
    const secondColor = getcolor(invColors);

    function getcolor(text) {
        try {
            const obj = JSON.parse(text);
            for (let key in obj) {
                if (typeof obj[key] === "string" && obj[key].match(/^#[0-9A-Fa-f]{3,6}$/)) {
                    return obj[key];
                }
            }
        } catch {
            return "#31b835";

        }
    };

    const styleToltal = {
        border: "solid 0.1px black",
        borderRadius: "6px",
        textAlign: "center",
        color: secondColor,
        fontWeight: "bold",
        padding: 2,
    };


    const sty = {
        cntr: { textAlign: "center", padding: 10, fontFamily: "Amiri-Regular" },
        lft: { textAlign: "left", padingLeft: 5 },
        rit: { textAlign: "right", padingRight: 5 },
        dirR: { direction: "rtl", color: "black" },
        dirL: { direction: "ltr", padding: 10 },
    };
    return (
        <Fragment>
            <Container style={{ direction: "rtl", fontFamily: "Amiri-Regular" }}>
                <Grid
                    item
                    container
                    // className={clas.BdytotSub}
                    style={{ paddingTop: "0.5rem", fontFamily: "Amiri-Regular",
                        direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Grid
                        item
                        xs={9}
                        container
                        className={calssBody.totalItem}
                        spacing={1}
                        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr"  }}
                    >
                        <Grid item xs={4} style={styleToltal}>
                            {(sta.tot.tot_net - sta.tot.amountOfVat).toFixed(2)}
                        </Grid>
                        <Grid item xs={7}>
                            {" الإجمالي  " + " " + txtE.totalAmount}
                        </Grid>
                        <Grid item xs={4} style={styleToltal}>
                            {sta.tot.discount.toFixed(2)}
                        </Grid>
                        <Grid item xs={7}>
                            {txtA.discount + " " + txtE.discount}
                        </Grid>
                        <Grid item xs={4} style={styleToltal}>
                            {sta.tot.amountOfVat.toFixed(2)}
                        </Grid>
                        <Grid item xs={7}>
                            {"(15%) ضريبة القيمة المضافة VAT"}
                        </Grid>
                        <Grid item xs={4} style={styleToltal}>
                            {sta.tot.tot_net.toFixed(2)}
                        </Grid>
                        <Grid item xs={7} style={styleToltal}>
                            <div style={{ fontWeight: "bold", }}>{tafqeet(sta.tot.tot_net, "SAR")}  {"فقط لا غير "} </div>
                        </Grid>
                    </Grid>
                    {locInv?.ProcTypeInvProc != "03" && locInv?.ProcTypeInvProc != "04" &&
                        <Grid item xs={3} container>
                            <QrBarcode locInv={locInv} InvForFatora={InvForFatora} color={secondColor} />
                        </Grid>
                    }

                    <Grid
                        item
                        container
                        xs={12}
                        spacing={1}
                        style={{ paddingTop: 10, fontWeight: "bold", textAlign: "center" }}
                    >
                        <Grid item xs={5}>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {" توقيع البائع" + "     " + " Salesmans Sign "}</div>
                            <br />
                            {/* <br /> */}
                            {"--------------------"}
                        </Grid>

                        {found?.footer_img != null ?
                            (
                                <Grid item xs={2}>
                                    <div>
                                        <ButtonBase>
                                            {" "}
                                            <img
                                                src={`data:image/jpeg;base64,${found?.footer_img}`}
                                                className={clas.Hedlogo}
                                                alt={found.nameA}
                                                style={{ height: 120, width: 120 }}
                                            />{" "}
                                        </ButtonBase>
                                    </div>
                                </Grid>
                            ) :
                            (
                                <Grid item xs={2}></Grid>
                            )
                        }
                        <Grid item xs={5}>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {"توقيع المستلم" + "     " + " Receivrs Sign "}</div>
                            <br />
                            {/* <br /> */}
                            {"--------------------"}

                        </Grid>

                    </Grid>
                </Grid>
                <Grid item container style={sty.cntr}>
                    <Grid item container>
                        <Grid item xs={12}>
                            {InvForFatora.notes}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            {locInv?.ProcTypeInvProc != "04" &&
                (
                    <Grid
                        item
                        container
                        style={{
                            fontWeight: "bold",
                            border: "solid 0.1px",
                            borderColor: secondColor,
                            direction: "ltr",
                            fontFamily: "Amiri-Regular"
                        }}
                    >
                        <Grid item xs={5} style={{ textAlign: "left" }}>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc1_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_en}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_en}</div>
                        </Grid>

                        <Grid item xs={2}></Grid>

                        <Grid
                            item
                            xs={5}
                            className={classHeader.rightHeader}
                            style={{ textAlign: "right" }}
                        >
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {found.Disc1_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_ar}</div>
                            <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_ar}</div>
                        </Grid>
                    </Grid>
                )}

        </Fragment>
    );
}
export default Footer;
